import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Select } from '../../styled-components/';

const Container = styled.div`
  display: flex;
  &.select2-container > input {
    background-position: center right 1rem;
    background-repeat: no-repeat;
    background-size: 1.25rem;
  }
`;

class LayerSelect extends Component {

  componentDidMount() {
    this.populateDropDown();
    $(this.input).on('select2:select', this.onChange);
  }

  componentDidUpdate() {
    this.populateDropDown();
  }

  componentWillUnmount() {
    $(this.input).select2('destroy');
    $(this.input).off('select2:select', this.onChange);
  }

  onChange = (event) => {
    const options = event.target.options;
    this.props.onChange(options[options.selectedIndex].value);
  }

  populateDropDown = () => {
    const data = this.props.layerList.map(d => ({ id: d, text: d, selected: d === this.props.value }));

    if(!data.includes(this.props.value)) {
      data.push({ id: this.props.value, text: this.props.value, selected: true })
    }

    $(this.input).select2({
      data,
      tags: true
    });
  }

  render() {
    return (
      <Container>
        <Select
          ref={(r) => (this.input = r)}
          {...this.props}
        />
      </Container>
    );
  }
}

LayerSelect.defaultProps = {
  onChange: () => {},
  selectedLayer: ''
};

LayerSelect.propTypes = {
  layerList: PropTypes.arrayOf(PropTypes.string),
  selectedLayer: PropTypes.string,
  onChange: PropTypes.func
};

export default LayerSelect;



// WEBPACK FOOTER //
// ./app/components/Editor/LayerSelect.js